import {StorageWrapper} from '../../../shared/scripts/StorageWrapper'
import {ViewPopup} from '../../../shared/scripts/ui_popup/ViewPopup'
import {PushNotificationPopupIntentEnum, USER_ACTION_ENUM} from '../notifications/UIMRequestPushNotificationController'
import {UIMDeviceHandler} from '../ui_html/UIMDeviceHandler'
import {CA} from '../../../shared/scripts/analytics/Analytics'
import {AnalyticEventCategory, AnalyticEventType} from '../../../../shared/entity_datas/EntityDatas'

export class UIMRequestPushNotificationOnFriendRequestPopup extends ViewPopup {
    constructor() {
        super({key: 'strings:homePage.popups.requestPushNotificationOnFriendRequest.title'},
            {key: 'strings:homePage.popups.requestPushNotificationOnFriendRequest.body'},
            () => {
                UIMDeviceHandler.requestNotificationPermission()
                void CA.sendAnalyticEvent({
                    type: AnalyticEventType.ABTestClickAnalytics,
                    category: AnalyticEventCategory.ABTestPushNotificationsPopup,
                    floatValue: USER_ACTION_ENUM.USER_ACCEPTED_PUSH_NOTIFICATION,
                    stringValue: PushNotificationPopupIntentEnum.OnUserSentFriendRequest,
                })
                StorageWrapper.setPushNotificationRequestStatus(true)
            },
            () => {
                void CA.sendAnalyticEvent({
                    type: AnalyticEventType.ABTestClickAnalytics,
                    category: AnalyticEventCategory.ABTestPushNotificationsPopup,
                    floatValue: USER_ACTION_ENUM.USER_REJECTED_PUSH_NOTIFICATION,
                    stringValue: PushNotificationPopupIntentEnum.OnUserSentFriendRequest,
                })
            },
            false,
            {
                checkButtonCustomContent: {key: 'strings:homePage.popups.requestPushNotificationOnFriendRequest.notifyMe'},
                xButtonCustomContent: {key: 'strings:homePage.popups.requestPushNotificationOnFriendRequest.notNow'},
            },)

        this.stylePopup()
        this.show()
    }

    private stylePopup() {
        this.body.classList.add('request-push-notification-body')
        this.xButton.classList.add('btn_ghost')
        this.xButton.style.maxWidth = 'unset'
        this.checkButton.style.maxWidth = 'unset'
    }
}
